var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{attrs:{"autoedit":_vm.edit,"disabled":_vm.disabled,"pendingGoodsInspectionCode":_vm.pendingGoodsInspectionCode,"pendingGoodsCode":_vm.pendingGoodsCode},on:{"add-success":_vm.addSuccess}})}
var staticRenderFns = []

export { render, staticRenderFns }